/**
 * Utility for selecting DOM element text.
 */

export const selectElementText = (el: HTMLElement) => {
  let range;
  let selection;

  if (window.getSelection && document.createRange) {
    selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents($(el)[0]);
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
    // @ts-ignore
  } else if (document.selection && document.body.createTextRange) {
    // @ts-ignore
    range = document.body.createTextRange();
    range.moveToElementText($(el)[0]);
    range.select();
  }
};
